<template>
  <div class="flex relative z-20 justify-between mt-8">
    <ul v-if="projectSwiper">
      <li v-for="i in 4" class="inline-block mr-1" :key="i">
        <button type="button" class="w-10 h-10 rounded-full border border-black cormorant font-semibold text-2xl flex justify-center items-center pb-2 mr-1" :class="projectSwiper.activeIndex === i-1? 'bg-lemon-normal': 'bg-white'" @click="slideTo(i-1)">
          {{ i }}
        </button>
      </li>
    </ul>
    <ul>
      <li class="inline-block mr-1">
        <button type="button" class="w-10 h-10 rounded-full border border-black bg-white flex justify-center items-center" @click="clickPrev">
          <svg class="mr-1" style="width:14px;height:14px" viewBox="0 0 24 24">
            <polygon fill="currentColor" points="3,12 24,0 24,24" />
          </svg>
        </button>
      </li>
      <li class="inline-block mr-1">
        <button type="button" class="w-10 h-10 rounded-full border border-black bg-white cormorant font-semibold flex justify-center items-center" @click="clickNext">
          <svg class="rotate-180 ml-1" style="width:14px;height:14px" viewBox="0 0 24 24">
            <polygon fill="currentColor" points="3,12 24,0 24,24" />
          </svg>
        </button>
      </li>
    </ul>
  </div>
  <div class="-mx-5 mt-6">
    <swiper
      :slides-per-view="1"
      @swiper="onSwiper"
    >
      <swiper-slide>
        <div class="px-5">
          <div class="px-16">
              <img class="w-full h-auto" :src="publickPath + '/images/project-1.png'">
          </div>
          <div>
            <div class="text-center mt-4">
              <h5 class="inline-block bg-lemon-normal font-bold text-2xl tracking-wider py-1 px-4">アパレル部門</h5>
            </div>
              <p class="text-xs tracking-wide leading-6 mt-6">
                  Cento trenta（チェント トレンタ）<br>
                  “イキる集団”による、紳士のためのセレクトショップ<br>
                  我々の根幹となる“服を通じて社会に福を生み出す”事業となります。高感度な国内外のレディ・メイドだけでなく、基本は押さえながらも常識や型に囚われない国内最高峰の縫製によるオーダースーツを強みとしています。<br>
                  また、関西最大級の衣料専門店、阪急メンズ大阪にある二号店では、最も多くのレディ・メイドを取り扱い特に「PT TORINO」の展開は、国内最大級の品揃えを誇る。 そして、多くのビジネスマンが行き交う大阪繊維業界の懐、三休橋筋にある三号店。仕事の合間に立ち寄れる好立地と、オン・オフ兼用できる商品構成で、忙しい大人達に洒脱な日常を提案しています。
              </p>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="px-5">
          <div class="px-16">
              <img class="w-full h-auto" :src="publickPath + '/images/project-2.png'">
          </div>
          <div>
            <div class="text-center mt-4">
              <h5 class="inline-block bg-lemon-normal font-bold text-2xl tracking-wider py-1 px-4">シューズ部門</h5>
            </div>
              <p class="text-xs tracking-wide leading-6 mt-6">
                D-TE SHOE STORE（ディーテ シュー ストア）<br>
                「靴のギャラリー」を目指し、世界中から名品だけを集めた靴専門セレクトショップ。“地に足付けろ”背伸びはいいけど、浮足だつな。Down To Erth（ダウン・トゥー・アース）我々の新しい“イキる”を叶える事業となります。<br>
                「Saint crispin’s」「VASS SHOES」といったブランドを取り扱い、店舗奥には靴磨きと修理を行う工房「THE SHOE SHINE GUILD」を併設し、購入からアフターケアまでをカバーしています。
              </p>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="px-5">
          <div class="px-16">
              <img class="w-full h-auto" :src="publickPath + '/images/project-3.png'">
          </div>
          <div>
            <div class="text-center mt-4">
              <h5 class="inline-block bg-lemon-normal font-bold text-2xl tracking-wider py-1 px-4">WEB部門</h5>
            </div>
              <p class="text-xs tracking-wide leading-6 mt-6">
                SNSなどの電子メディアを通じ、デジタルマーケティングを駆使した、訴求と “ライフスタイリスト”それぞれの個性を際立たせたデジタルコミュニケーションを軸に、それらをより先進的に進め、業界に変容（DX Digital Transformation）をもたらす戦略を推進していく、我々にとってこれからの中核を担う事業になります。<br>
                世界から厳選したアイテムだけにとどまらず、コト・モノ、その他あらゆる革新をWEBをとおし、“ライフスタイリスト”の価値と福を全国へ発信していきます。
              </p>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="px-5">
          <div class="px-16">
              <img class="w-full h-auto" :src="publickPath + '/images/project-4.png'">
          </div>
          <div>
            <div class="text-center mt-4">
              <h5 class="inline-block bg-lemon-normal font-bold text-2xl tracking-wider py-1 px-4">ディストリビューター</h5>
            </div>
              <p class="text-xs tracking-wide leading-6 mt-6">
                海外ファクトリーブランドを中心に、独自の審美眼で見初めた逸品や、いまだ野に埋もれ、芽吹くことを待ちわびている傑作、あるいは、表舞台に出られずくすぶり続けている珠玉の名品たちまで<br>
                世界各国から選び抜いた“モノ”たちを、<br>
                国内リテーラーをつうじて、日本国内の“ヒト”たちに福を生み出す事業となります。
              </p>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { ref } from 'vue';
import { computed } from '@vue/reactivity';
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const projectSwiper = ref(null);
    const onSwiper = (swiper) => {
      projectSwiper.value = swiper;
    }
    const clickNext = () => {
        projectSwiper.value.slideNext()
    }
    const clickPrev = () => {
        projectSwiper.value.slidePrev()
    }
    const slideTo = (index) => {
      projectSwiper.value.slideTo(index)
    }

    const publickPath = computed(() => {
      if (process.env.NODE_ENV === 'production') {
        return '/recruit'
      } else {
        return ''
      }
    })
    return {
      onSwiper,
        publickPath,
        projectSwiper,
        clickNext,
        clickPrev,
        slideTo
    }
  }
}
</script>
